export default __webpack_public_path__ + "static/media/KGMissKindyChunky.bd1ef3c4.ttf";